<template>
  <div style="padding:10px 20px">
    <RatioSetting />
  </div>
</template>
<script route="/hr/payment-manage/payment-proportion">
  import RatioSetting from '@/views/fin/salaryadministration/components/RatioSetting.jsx'
  export default {
    components: {
      RatioSetting
    }
  }
</script>